import { getRecoil} from 'recoil-nexus';
import { BaseURL, AppEnv, ENV_LIST} from '../environment';
import { currentEnvironment } from '../Recoil-State';
export const excludeAccessRoleAppList = ['ACLG', 'S360', 'OCL', 'IVS', 'PIM', 'Reltio', 'CAP', 'PUEBLO', 'INTERRO', 'OPTIC', 'COACH', 'TRED','USMAM','AsaAdmin','ASAONE'];
export const excludePermissionAppList = ['INTERRO'];
export const excludeEnvAppList = ['INTERRO'];
/**
 * Redirect to home fxhub application
 */

export const RedirectToHome =() => {
    if( AppEnv !=='local') {
        window.location.assign(BaseURL);
    }
}


export const RandomId = () =>Math.random().toString(16).slice(2);

export const extractError =(response) => {
    let { error_cause , error_description} = response;
    let errorMessage = error_description;

    if ( error_cause && error_cause.error_message) {
        errorMessage =  error_cause.error_message;
    } 
    return  errorMessage;
}


/**
 * This method do not call on load time since recoil is not supported by the loading time
 * @param {string } url 
 * @returns 
 */
export const GetURLRequestAccess = (url, isLookUp = false) => {
    let ENV = getRecoil(currentEnvironment);
    if (['uat', 'test', 'poc', 'dev'].includes(ENV) && !isLookUp) {
        let { GENERIC_API } = ENV_LIST['prod'] || {};
        url = `${GENERIC_API}/${url}` ;
    }
    return url;
}

